import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import NoData from "@/components/NoData/index.vue";
import CloudCard from "@/components/CloudCard/index.vue";
export default /*#__PURE__*/ _defineComponent({
    name: 'index',
    props: {
        icon: { default: "test" },
        text: { default: "内测中，敬请期待" }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(CloudCard, { class: "content" }, {
                default: _withCtx(() => [
                    _createVNode(NoData, {
                        icon: __props.icon,
                        text: __props.text
                    }, {
                        info: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "info")
                        ]),
                        _: 3
                    }, 8, ["icon", "text"])
                ]),
                _: 3
            }));
        };
    }
});
